import {
  formatProfileLinkValue,
  getProfileLinkUrl,
  profileLinkServiceIds,
} from '@/resources/profile-link-services'
import { z } from 'zod'

export const profileLinkSchema = z
  .object({
    service: z.enum(profileLinkServiceIds, {
      error: 'Please select a supported service.',
    }),
    username: z
      .string()
      .trim()
      .min(1, 'Enter a username or link.')
      .max(500, 'Links must be 500 characters or fewer.'),
    showOnProfile: z.boolean().default(true),
  })
  .transform((profileLink, ctx) => {
    const username = formatProfileLinkValue(
      profileLink.service,
      profileLink.username,
    )
    const url = getProfileLinkUrl(profileLink.service, username)

    if (!username || !url) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['username'],
        message: 'Enter a valid username or link.',
      })
      return z.NEVER
    }

    if (profileLink.service === 'website') {
      try {
        const parsedUrl = new URL(url)
        if (!parsedUrl.hostname.includes('.')) throw new Error('Invalid host')
      } catch {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['username'],
          message: 'Enter a valid website URL.',
        })
        return z.NEVER
      }
    }

    return {
      ...profileLink,
      username,
    }
  })
